import './App.css';
import hero from './hero.jpg';
import profile from './profile.jpg';
import groothstudio from './groothstudio.png';
import LightRays from './LightRays';
import { lazy, Suspense } from "react";

import second from './Gallery/2.jpg'
import eighth from './Gallery/8.jpg'
import Gallery from './Gallery'
const Aurora = lazy(() => import("./Aurora"));

const currentYear = new Date().getFullYear();
function App() {
  return (
    <div className='h-auto bg-[#111111] m-0 p-0 box-content'>
      <div className="min-w-full h-screen max-h-screen flex items-center justify-center overflow-hidden">
        <div className='xl:aspect-auto lg:m-8 2xl:m-10 relative w-auto 2xl:w-[1829px] 2xl:h-[897px] h-screen sm:h-auto max-h-[90%] content-center overflow-hidden' alt="hero">

            <ul className='text-sm font-montserrat bg-[#111111] list-none xl:hidden flex flex-row items-center justify-center px-20 gap-8 absolute top-0 left-[50%] transform -translate-x-1/2 rounded-2xl'>
              <li className='text-[#DDDDDD]'><button>Home</button></li>
              <li className='text-[#DDDDDD]'><button  onClick={() => document.getElementById('gallery')?.scrollIntoView({behavior:'smooth'})}>Gallery</button></li>
              <li className='text-[#DDDDDD]'><button onClick={() => document.getElementById('about')?.scrollIntoView({behavior:'smooth'})}>About</button></li>
            </ul>

            <img src={hero} loading='lazy' className='hidden sm:block w-full h-auto object-cover rounded-t-[2.5rem]' alt="hero" />

            <div className='lg:hidden grid grid-rows-3 grid-cols-1 gap-2 max-h-[80vh] justify-center items-center mx-8'>
              <img src={second} loading='lazy' className='sm:hidden w-full h-full object-cover rounded-t-[2.5rem]' alt="hero" />
              <img src={hero} loading='lazy' className='sm:hidden w-full h-full object-cover' alt="hero" />
              <img src={eighth} loading='lazy' className='sm:hidden w-full h-full object-cover rounded-br-[2.5rem]' alt="hero" />
            </div>
            
            <ul className='hidden text-lg font-montserrat absolute bg-[#111111] list-none sm:flex flex-row items-center justify-center -top-5 left-[50%] transform -translate-x-1/2 rounded-2xl px-20 py-5 gap-16'>
              <li className='text-[#DDDDDD]'><button>Home</button></li>
              <li className='text-[#DDDDDD]'><button onClick={() => document.getElementById('gallery')?.scrollIntoView({behavior:'smooth'})}>Gallery</button></li>
              <li className='text-[#DDDDDD]'><button onClick={() => document.getElementById('about')?.scrollIntoView({behavior:'smooth'})}>About</button></li>
            </ul>

            <div className='hidden bg-[#111111] sm:flex absolute text-[#DDDDDD] text-center justify-center items-center text-lg font-montserrat w-36 h-14 sm:top-6 right-5 rounded-full'>
              <button onClick={() => document.getElementById('footer')?.scrollIntoView({behavior:'smooth'})} className='text-[#DDDDDD]'>Contact</button>
            </div>

            <div className="absolute bottom-0 w-full h-4/6 bg-gradient-to-t from-[#111111]/90 via-black/40 to-transparent"></div>

            <div className='flex justify-center flex-col absolute bottom-24 sm:bottom-32 left-0 sm:left-20 text-5xl sm:text-6xl gap-3 mx-8 sm:mx-0'>
              <h1 className='text-[#DDDDDD] font-bold'>Culbert</h1>
              <p className='text-gray-400 font-[500] pb-4'>Nico Karim</p>
              <p className='text-gray-400 font-[500] text-xl'>Capturing moments around you!</p>
            </div>
          </div>
      </div>

      <div id='about' className='h-screen max-h-screen w-full overflow-hidden flex items-center justify-center'>
        <div className='w-full h-full relative m-5 2xl:m-10 rounded-[2.5rem] overflow-hidden'>
          <div className='isolate flex flex-col sm:flex-row items-center justify-center h-full w-full gap-20 lg:gap-20 2xl:gap-28 z-10'>
            <img src={profile} className='aspect-square w-72 lg:w-96 xl:w-[26rem] 2xl:w-[32rem] h-auto rounded-[4rem] object-cover grayscale' alt="Profile" />
            <div className='w-9/12 sm:w-5/12 text-gray-500 text-lg font-montserrat text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl'>
              <p className='text-white'>Culbert Nico Karim</p>
              <p>Aviation & lifestyle <span className='text-white'>photographer</span> based in Indonesia.</p>
              <p><span className='text-white'>Indonesia</span>, or wherever the light shines.</p>
              <p>Need a shoot? <span className='text-white'>Contact Me!</span></p>
            </div>
          </div> 
          <div className='absolute inset-0 -z-2'>
            <LightRays
            raysOrigin="top-right"
            raysColor="#9FBBCC"
            raysSpeed={1}
            lightSpread={0.5}
            rayLength={3}
            mouseInfluence={0}
            noiseAmount={0}
            distortion={0}
            fadeDistance={2}
            saturation={0}
            />
          </div>

          <div className='absolute inset-0 -z-1'>
            <LightRays
            raysOrigin="bottom-left"
            raysColor="#af4c56"
            raysSpeed={1}
            lightSpread={0.5}
            rayLength={3}
            mouseInfluence={0}
            noiseAmount={0}
            distortion={0}
            fadeDistance={2}
            saturation={0}
            />
          </div>
          </div>
        </div>

      <div id='gallery'>
        <Gallery />
      </div>

      <div className='relative w-full h-auto overflow-hidden'>

        <div className='hidden sm:block absolute inset-0 rotate-180'>
          <Suspense>
            <Aurora
              colorStops={["#9fbbcc","#92a4b0","#af4c56"]}
              blend={0.5}
              amplitude={0.5}
              speed={0.5}
            />
          </Suspense>
        </div>

        <div id='footer' className='grid grid-cols-1 sm:grid-cols-2 mx-6 sm:mx-14 xl:mx-16'>

          <div className='isolate font-montserrat text-[#DDDDDD] text-4xl lg:text-5xl my-10'>
            <h2 className='font-bold'>Culbert Nico Karim</h2>
            <p className='font-[350]'>Canon EOS 70D</p>
            <p className='font-[350]'>Medan, Indonesia</p>
          </div>

          <div className='isolate mb-20 sm:my-14 sm:justify-self-end bg-[#DDDDDD] rounded-3xl w-52 h-10 sm:w-64 sm:h-12 flex items-center justify-center'>
            <button className='font-semibold xl:text-lg 2xl:text-xl text-[#111111]'><a href='https://wa.me/+6282193842150?hi' target='_blank' rel='noopener noreferrer'>Get a Consultation</a></button>
          </div>

        </div>

        <div className='grid grid-cols-2 sm:grid-cols-3 mx-6 sm:mx-14 xl:mx-16 gap-0'>

          <div className='flex flex-col gap-14 sm:justify-self-end sm:col-span-2'>
            <div className='isolate flex flex-col font-montserrat text-[#DDDDDD] gap-2'>
              <h3 className='text-2xl sm:text-3xl font-semibold'>Location</h3>
              <p>Indonesia</p>
            </div>
            <div className='isolate flex flex-col font-montserrat text-[#DDDDDD] gap-2'>
              <h4 className='text-2xl sm:text-3xl font-semibold'>Social</h4>
              <p><a href="https://www.instagram.com/aero.peanut" target="_blank" rel="noopener noreferrer">Instagram</a></p>
              <p><a href="https://www.threads.com/@smokypeanut" target="_blank" rel="noopener noreferrer">Threads</a></p>
            </div>
          </div>

          <div className='isolate flex flex-col font-montserrat text-[#DDDDDD] gap-2 text-left sm:text-right'>
            <h4 className='text-2xl sm:text-3xl font-semibold'>Contact</h4>
            <p><a href="https://wa.me/+6282193842150?hi" target="_blank" rel="noopener noreferrer">+62 821 9384 2150</a></p>
            <p><a href="mailto:aeropeanut@gmail.com" target='_blank' rel="noopener noreferrer" >aeropeanut@gmail.com</a></p>
          </div>

        </div>

        <div className='isolate grid grid-rows-3 mt-20 py-10 font-montserrat mx-6 sm:mx-14 mx-4 xl:mx-16'>
          <p className='text-sm sm:text-base text-center text-[#DDDDDD]'>&copy; {currentYear} Grooth Studio. All rights reserved.</p>
          <hr className='justify-self-center w-full border-t border-[#D9D9D9] my-2 sm:my-4'></hr>
          <p className='justify-self-start text-[#FFFFFF] text-md sm:text-lg'>Website designed & developed by</p>
          <div className='flex flex-row items-center align-center justify-self-start'>
            <img src={groothstudio} alt="Grooth Studio" className='h-5 sm:h-8' />
            <a href='https://grooths.com' target='_blank' rel="noopener noreferrer" className='text-sm sm:text-base ml-2 text-[#F5F5F5]'>Grooth Studio</a>
          </div>
        </div>

      </div>
      </div>
  );
}

export default App;
